import React,{useEffect} from 'react';
import './Cards.scss'
import { Container, Row, Col } from 'react-bootstrap';

import {
    ImgCarBridge,
    ImgManBridge,
    ImgUnderpass,
    ImgDisaster,
    ImgDetailTestAnalyze
} from '../../../style/images/system-icons'

const CardDashboard = ({func}) => {
    const display = () => {
        let temp = []
        if (func.length>0){
            func.forEach(item=>{
                if (item.name.includes("車行橋")){
                    temp.push(<Col className='col-lg-4 col-3 p-3' key={item.key}>
                    <div className="text-center">
                        <img src={ImgCarBridge} width="50" alt="" />
                        <div><a target="_self" href="./Dashboard/CarBridge/">車行橋</a></div>
                    </div>
                </Col>)
                }else if (item.name.includes("人行橋")){
                    temp.push(                <Col className='col-lg-4 col-3 p-3' key={item.key}>
                    <div className="text-center">
                        <img src={ImgManBridge} width="50" alt="" />
                        <div><a target="_self" href="./Dashboard/ManBridge/">人行橋</a></div>
                    </div>
                </Col>)
                }else if (item.name.includes("地下道")){
                    temp.push(                <Col className='col-lg-4 col-3 p-3' key={item.key}>
                    <div className="text-center">
                        <img src={ImgUnderpass} width="50" alt="" />
                        <div><a target="_self" href="./Dashboard/Underpass/">地下道</a></div>
                    </div>
                </Col>)
                 }
            })
        }
        return temp;
    }
    const displaySec = () => {
        let temp = []
        if (func.length>0){
            func.forEach(item=>{
                if (item.name.includes("防災資訊")){
                    temp.push(                <Col className='col-lg-4 col-3 p-3' key={item.key}>
                    <div className="text-center">
                        <img src={ImgDisaster} width="50" alt="" />
                        <div><a target="_self" href="./Dashboard/DisasterPrevention/basic">防災資訊</a></div>
                    </div>
                </Col>)
                }else if (item.name.includes("詳檢分析")){
                    temp.push(                <Col className='col-lg-4 col-3 p-3' key={item.key}>
                    <div className="text-center">
                        <img src={ImgDetailTestAnalyze} width="50" alt="" />
                        <div><a target="_self" href="./Dashboard/DetailTestAnalyze/">詳檢分析</a></div>
                    </div>
                </Col>)
                
                }
            })
        }
        return temp;
    }

    return (
        <Container>
            <Row>
            <h4 className="l-system-switch-panel__title text-left mb-3">儀表板</h4>
            </Row>
            <Row>
                    {display()}
                {displaySec()}
            </Row>
        </Container>
    )
}
export default CardDashboard;